// extracted by mini-css-extract-plugin
export default {"cls1":"Comments-cls1___b5da05b5078972a476a","cls2":"Comments-cls2___988f2afcc228bae783b Comments-cls1___b5da05b5078972a476a"};